import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EnvironmentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: `${theme.palette.primary.main}E6`,
  color: theme.palette.primary.contrastText,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  position: "fixed",
  bottom: 0,
  right: 0,
  borderTopLeftRadius: 20,
}));
